import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { AggregateSizeFraction } from 'Components/Worksheets/LosAngelesValueWorksheet/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import BsEnPortionDryMassSection from '../Shared/PortionDryMassSection';
import BsEnMeasurementsExtraSieveSection from './MeasurementsExtraSieveSection';

let BsEnMeasurementsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isRailwayBallast = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.AggregateSizeFraction'),
      (d) => d === AggregateSizeFraction.Sizes31_5mmTo50mm
    )
  );

  const useAdditionalSieve = useSelector(
    pipe(createWorksheetSelector!('Preparation.UseAdditionalSieve'), valueOrDefault(false))
  );

  return (
    <NamePrefixModifier appendNamePrefix="Measurements">
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Balance" />
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="la-machine" name="LAMachine" />
        <Field input={<NumericInput />} name="NoOfBalls" />
        <Field input={<NumericInput />} name="MassOfBalls" />
        <Field input={<NumericInput />} name="NoOfRevolutions" />
        {isRailwayBallast && (
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="sieve"
            name="SeparationSieve"
            queryParams={{
              SieveSize: '8.00 mm:31.5 mm',
            }}
          />
        )}
      </ListFieldSection>

      {!isRailwayBallast && (
        <>
          <NamePrefixModifier appendNamePrefix="WashedRecoveredRetainedAggregate">
            <BsEnPortionDryMassSection
              label="Washed Recovered Retained Aggregate"
              showGuardSieve
              hideConstantDrySoilMass
            />
          </NamePrefixModifier>
          <ListFieldSection>
            <Field input={<TextOutput />} name="RecoveredAggregateDryMassRetained" />
          </ListFieldSection>
        </>
      )}
      {isRailwayBallast && (
        <>
          <NamePrefixModifier appendNamePrefix="CoarsePortionRecoveredRetainedAggregate">
            <BsEnPortionDryMassSection label="Coarse Portion Recovered Retained Aggregate" showGuardSieve />
          </NamePrefixModifier>

          <NamePrefixModifier appendNamePrefix="FinePortionRecoveredRetainedAggregate">
            <BsEnPortionDryMassSection label="Fine Portion Recovered Retained Aggregate" showGuardSieve />
          </NamePrefixModifier>

          <ListFieldSection>
            <Field input={<TextOutput />} name="RecoveredAggregateDryMassRetained" />
          </ListFieldSection>

          {useAdditionalSieve && <BsEnMeasurementsExtraSieveSection />}
        </>
      )}
    </NamePrefixModifier>
  );
};

BsEnMeasurementsSection = withInjectedProps(BsEnMeasurementsSection);

export { BsEnMeasurementsSection };
export default BsEnMeasurementsSection;
